/*
**************************** 
홈페이지 콘텐츠(구버전)
*****************************
*/

import React from "react";

export default function Contents() {
    return (
        <div>
            <div className="mt-5 pt-2">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item small"><a href="#">톡톡박스</a></li>
                    <li className="breadcrumb-item active small">톡톡콘텐츠</li>
                </ol>
            </div>
            <div className="container">
                <div className="w-100">
                    <img className="w-100 img-fluid" src="/img/toktok_contents_1_m.png" alt=""></img>
                    <img className="w-100 img-fluid" src="/img/toktok_contents_2_m.png" alt=""></img>
                    <img className="w-100 img-fluid" src="/img/toktok_contents_3_m.png" alt=""></img>
                </div>
            </div>
        </div>


    )
}